// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SetPasswordForUserRequestModel from '../../model/set-password-for-user-request-model';
import SetPasswordForUserRequestDTO from '../dto/set-password-for-user-request-dto';
import dtoSchema from '../schemas/set-password-for-user-request-schema';

export default abstract class SetPasswordForUserRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SetPasswordForUserRequestDTO>) {
    super();
    if (data) {
      this.newPassword = data.newPassword;
      this.repeatNewPassword = data.repeatNewPassword;
      this.id = data.id;
    }
  }
  /**
  * @minimum 6
  */
  newPassword?: string;
  /**
  * @minimum 6
  */
  repeatNewPassword?: string;
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<SetPasswordForUserRequestDTO>): SetPasswordForUserRequestModel;
  static toModel(dto: DeepPartial<SetPasswordForUserRequestDTO> | undefined | null): SetPasswordForUserRequestModel | undefined;
  static toModel(dto: DeepPartial<SetPasswordForUserRequestDTO> | undefined | null): SetPasswordForUserRequestModel | undefined {
    return dto ? new SetPasswordForUserRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SetPasswordForUserRequestModel> | SetPasswordForUserRequestModel): SetPasswordForUserRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      newPassword: unwrapped.newPassword,
      repeatNewPassword: unwrapped.repeatNewPassword,
      id: unwrapped.id,
    } as SetPasswordForUserRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SetPasswordForUserRequestModel, can not map to SetPasswordForUserRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
